import { useLang } from "@/context/LanguageContext";
import { Globe, ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export default function LanguageSwitcher({ inMobileMenu = false }) {
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.code === lang) || langs[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className={`relative ${inMobileMenu ? "" : ""}`} ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="lang-switcher-btn"
        className="flex items-center gap-2 font-ui text-[10px] tracking-[0.25em] uppercase font-semibold text-[#111111] hover:text-[#6C6C6C] transition-colors border border-[#DCDCDC] px-3 py-2"
      >
        <Globe size={13} strokeWidth={1.5} />
        <span className="hidden md:inline">{current.native}</span>
        <span className="md:hidden">{current.code.toUpperCase()}</span>
        <ChevronDown size={12} strokeWidth={1.5} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 min-w-[180px] bg-white border border-[#111111] z-50" data-testid="lang-menu">
          {langs.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`lang-option-${l.code}`}
              className={`block w-full text-left px-4 py-3 font-ui text-[11px] tracking-[0.2em] uppercase font-semibold border-b border-[#DCDCDC] last:border-b-0 transition-colors ${
                l.code === lang ? "bg-[#111111] text-white" : "text-[#111111] hover:bg-[#F5F5F5]"
              }`}
              style={l.dir === "rtl" ? { direction: "rtl", textAlign: "right" } : {}}
            >
              {l.native}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
